import { buildBuiltinScheme, buildSection } from './builder'

export const productScheme = buildBuiltinScheme(
  {
    id: 'builtin-product',
    name: '产品图 · 电商级',
  },
  [
    buildSection('风格基调', 0, ['product photography', 'commercial still life']),
    buildSection('主体物品', 1, ['ceramic pour-over coffee dripper']),
    buildSection('材质描述', 2, ['matte ceramic', 'subtle glaze texture']),
    buildSection('场景 / 背景', 3, ['clean studio backdrop', 'soft beige gradient']),
    buildSection('支持道具', 4, ['linen cloth', 'fresh coffee beans scattered']),
    buildSection('光线描述', 5, ['softbox key light', 'gentle shadow', 'no harsh reflection']),
    buildSection('构图与镜头', 6, ['three-quarter view', '50mm', 'centered composition']),
    buildSection('色彩方案', 7, ['warm neutral palette', 'muted earth tones']),
    buildSection('质量描述', 8, ['ultra sharp', 'high detail', 'catalog-ready']),
  ],
  {
    ar: '1:1',
    v: '6.1',
    style: 'raw',
    q: 2,
    s: 150,
  },
)
